export default {
  title: {
    id: 'product_page_customization_title',
    defaultMessage: 'Let’s find you one in our marketplace.',
  },
  titleStepGrade: {
    id: 'product_page_customization_step_grade_title',
    defaultMessage: 'What {emphasis, html} are you looking for?',
  },
  titleStepBattery: {
    id: 'product_page_customization_step_battery_title',
    defaultMessage: 'Do you need extra {emphasis, html}?',
  },
  titleStepStorage: {
    id: 'product_page_customization_step_storage_title',
    defaultMessage: 'How much {emphasis, html} do you need?',
  },
  titleStepSim: {
    id: 'product_page_customization_step_sim_title',
    defaultMessage: 'What {emphasis, html} do you need?',
  },
  titleStepColor: {
    id: 'product_page_customization_step_color_title',
    defaultMessage: 'Lastly, what {emphasis, html} do you like most?',
  },
  titleEmphasisStepGrade: {
    id: 'product_page_customization_step_grade_emphasis',
    defaultMessage: 'aesthetic',
  },
  titleEmphasisStepBattery: {
    id: 'product_page_customization_step_battery_emphasis',
    defaultMessage: 'battery life',
  },
  titleEmphasisStepStorage: {
    id: 'product_page_customization_step_storage_emphasis',
    defaultMessage: 'storage',
  },
  titleEmphasisStepSim: {
    id: 'product_page_customization_step_sim_emphasis',
    defaultMessage: 'SIM',
  },
  titleEmphasisStepColor: {
    id: 'product_page_customization_step_color_emphasis',
    defaultMessage: 'color',
  },
  newBatteryOptionNo: {
    id: 'product_page_customization_step_battery_option_no',
    defaultMessage: 'Default battery',
  },
  newBatteryOptionYes: {
    id: 'product_page_customization_step_battery_option_yes',
    defaultMessage: 'New battery installed',
  },
  helpCardBattery: {
    id: 'product_page_customization_step_battery_help',
    defaultMessage: 'See if your phone usage actually requires a new battery.',
  },
  resultTitle: {
    id: 'product_page_customization_result_title',
    defaultMessage: 'Tadaaaa!',
  },
  resultSeller: {
    id: 'product_page_customization_result_seller',
    defaultMessage: 'Proudly refurbished by {seller, html}',
  },
  resultAcceptedPaymentMethods: {
    id: 'product_page_customization_result_accepted_payment_methods',
    defaultMessage: 'Accepts',
  },
}
